import React, { Suspense, useState } from 'react';
import { useRoutes } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import Root from './Root';

// All layouts/containers
import DefaultLayout from '../layouts/Default';
import VerticalLayout from '../layouts/Vertical';
// lazy load all the views

//import Maintenance from '../pages/maintenance';

// account
const Login = React.lazy(() => import('../pages/account/Login'));
const LoginCompany = React.lazy(() => import('../pages/account/LoginCompany'));
const Logout = React.lazy(() => import('../pages/account/Logout'));
const Confirm = React.lazy(() => import('../pages/account/Confirm'));
const ForgetPassword = React.lazy(() => import('../pages/account/ForgetPassword'));
const ForgetPasswordCompany = React.lazy(() => import('../pages/account/ForgetPasswordCompany'));
const RegisterCompany = React.lazy(() => import('../pages/account/RegisterCompany'));
const RegisterClient = React.lazy(() => import('../pages/account/RegisterClient'));

// pages
const Contact = React.lazy(() => import('../pages/contact/Contact'));
const Files = React.lazy(() => import('../pages/files/Files'));
const FileNew = React.lazy(() => import('../pages/files/FileNew'));
const Profile = React.lazy(() => import('../pages/profile/Detail'));
const ResetPassword = React.lazy(() => import('../pages/account/ResetPassword'));
const ChangePassword = React.lazy(() => import('../pages/profile/ChangePassword'));
const ClientStatements = React.lazy(() => import('../pages/statements/Statements'));
const ClientDetail = React.lazy(() => import('../pages/profile/Detail'));
const ClientDocuments = React.lazy(() => import('../pages/documents/Documents'));

const loading = () => <div className=""></div>;

const LoadComponent = ({
  component: Component,
  searchOptions,
  setSearchOptions,
  confirmDeleteModal,
  setConfirmDeleteModal,
}) => (
  <Suspense fallback={loading()}>
    <Component
      searchOptions={searchOptions}
      setSearchOptions={setSearchOptions}
      confirmDeleteModal={confirmDeleteModal}
      setConfirmDeleteModal={setConfirmDeleteModal}
    />
  </Suspense>
);

const AllRoutes = () => {
  const [searchOptions, setSearchOptions] = useState({
    executeSearch: false,
    showSearch: true,
    showButton: true,
    screen: '',
    fields: {
      search: {
        label: 'Pesquisar...',
        type: 'input',
        value: '',
      },
    },
  });
  const [confirmDeleteModal, setConfirmDeleteModal] = useState({
    show: false,
    deleteMethod: null,
    refreshMethod: null,
  });

  let Layout = VerticalLayout;
  
  // return useRoutes([
  //  { path: '*', element: <LoadComponent component={Maintenance} /> },
  // ]);

  return useRoutes([
    // public routes
    { path: '/', element: <Root /> },
    {
      path: '/',
      element: <DefaultLayout />,
      children: [
        {
          path: 'account',
          children: [
            { path: 'login', element: <LoadComponent component={Login} /> },
            { path: 'login-company', element: <LoadComponent component={LoginCompany} /> },
            { path: 'confirm', element: <LoadComponent component={Confirm} /> },
            { path: 'reset-password/:uid/:token', element: <LoadComponent component={ResetPassword} /> },
            { path: 'forget-password', element: <LoadComponent component={ForgetPassword} /> },
            { path: 'forget-password-company', element: <LoadComponent component={ForgetPasswordCompany} /> },
            { path: 'register-company', element: <LoadComponent component={RegisterCompany} /> },
            { path: 'register-client', element: <LoadComponent component={RegisterClient} /> },
            { path: 'logout', element: <LoadComponent component={Logout} /> },
          ],
        },
      ],
    },
    {
      // auth protected routes
      path: '/',
      element: (
        <PrivateRoute
          component={Layout}
          searchOptions={searchOptions}
          setSearchOptions={setSearchOptions}
          confirmDeleteModal={confirmDeleteModal}
          setConfirmDeleteModal={setConfirmDeleteModal}
        />
      ),
      children: [
        {
          path: 'files',
          element: (
            <LoadComponent
              component={Files}
              searchOptions={searchOptions}
              setSearchOptions={setSearchOptions}
              confirmDeleteModal={confirmDeleteModal}
              setConfirmDeleteModal={setConfirmDeleteModal}
            />
          ),
        },
        {
          path: 'files/:fileId',
          element: (
            <LoadComponent
              component={FileNew}
              searchOptions={searchOptions}
              setSearchOptions={setSearchOptions}
              confirmDeleteModal={confirmDeleteModal}
              setConfirmDeleteModal={setConfirmDeleteModal}
            />
          ),
        },
        {
          path: 'contact',
          element: (
            <LoadComponent
              component={Contact}
              searchOptions={searchOptions}
              setSearchOptions={setSearchOptions}
              confirmDeleteModal={confirmDeleteModal}
              setConfirmDeleteModal={setConfirmDeleteModal}
            />
          ),
        },
        {
          path: 'profile',
          element: (
            <LoadComponent
              component={Profile}
              searchOptions={searchOptions}
              setSearchOptions={setSearchOptions}
              confirmDeleteModal={confirmDeleteModal}
              setConfirmDeleteModal={setConfirmDeleteModal}
            />
          ),
        },
        {
          path: 'profile/password',
          element: (
            <LoadComponent
              component={ChangePassword}
              searchOptions={searchOptions}
              setSearchOptions={setSearchOptions}
              confirmDeleteModal={confirmDeleteModal}
              setConfirmDeleteModal={setConfirmDeleteModal}
            />
          ),
        },
        {
          path: 'statements',
          element: (
            <LoadComponent
              component={ClientStatements}
              searchOptions={searchOptions}
              setSearchOptions={setSearchOptions}
              confirmDeleteModal={confirmDeleteModal}
              setConfirmDeleteModal={setConfirmDeleteModal}
            />
          ),
        },
        {
          path: 'portalcliente/clients/:clientId/detail',
          element: (
            <LoadComponent
              component={ClientDetail}
              searchOptions={searchOptions}
              setSearchOptions={setSearchOptions}
              confirmDeleteModal={confirmDeleteModal}
              setConfirmDeleteModal={setConfirmDeleteModal}
            />
          ),
        },
        {
          path: 'documents',
          element: (
            <LoadComponent
              component={ClientDocuments}
              searchOptions={searchOptions}
              setSearchOptions={setSearchOptions}
              confirmDeleteModal={confirmDeleteModal}
              setConfirmDeleteModal={setConfirmDeleteModal}
            />
          ),
        },
      ],
    },
    { path: '*', element: <Root /> },
  ]);
};

export { AllRoutes };
